(function($) {
var toggleAffix = function(affixElement, scrollElement, wrapper) {
  var height = affixElement.outerHeight(),
    top = wrapper.offset().top;

  if (scrollElement.scrollTop() >= top) {
    wrapper.height(height);
    affixElement.addClass("affix");
  } else {
    affixElement.removeClass("affix");
    wrapper.height("auto");
  }
};

/**
 * Cloning menu for responsive
 */
function cloneMenu(id) {
  // Cloning and adding responsive class for mobile layout
  clone = $(id)
    .clone()
    .addClass("navbar--mobile");

  // Check if each menu-item has a dropdown submenu
  $(clone)
    .attr("id", "sidebar")
    .find(".menu-item")
    .each(function() {
      if ($(this).hasClass("dropdown")) {
        // Add arrow to navigate to submenu
        $(this).append(
          '<button type="button" class="deploy-dropdown"><i class="fas fa-angle-down text-white"></i></button>'
        );
      }
    });

  // remove .collapse classes from menu divs
  $(clone)
    .find(".collapse")
    .each(function() {
      $(this).removeClass("collapse navbar-collapse");
    });

  // Add dismiss button and title from parent item to each dropdown submenu
  $(clone)
    .find(".dropdown-menu")
    .each(function() {
      var itemTitle = $(this)
        .prev()
        .children()
        .html();
      if (
        $(this)
          .prev()
          .hasClass("dropdown-toggle")
      ) {
        itemTitle = $(this)
          .prev()
          .html();
      }
    });

  // Add cloned navigation to the header
  $(id)
    .parent()
    .append(clone);
}

function toggleActiveRow(el){
  
  var appNumber = el.children('.cell--appartmentName').html();
  var appRooms  = el.children('.cell--rooms').html();
  var appArea   = el.children('.cell--area').html();
  var appTerrace= el.children('.cell--terrace').html();
  var appPrice  = el.children('.cell--price').html();
  var appLink   = el.find('a').attr('href');
  var appImg    = el.data('img');

  $('.table__row.d-none').removeClass('d-none');
  el.addClass('d-none');

  
  if(appTerrace.length) {
    appArea += ' + Terrasse '+ appTerrace + '&nbsp;m<sup>2<sup>';
  }

  if($('.table__row.active').length){
    $('.table__row.active').remove();
  }

  el.after(function(){
    return '<tr class="table__row active"><td colspan="5"><div class="data__container d-flex"><h3 class="cell--appartmentName">'+ appNumber +'</h3><div class="left"><ul><li class="cell-rooms">'+ appRooms +'</li><li class="cell--area">Surface '+ appArea +'</li><li class="cell--price">'+ appPrice +'</li></ul><a class="cell--link btn btn-sm btn-secondary" href="'+ appLink +'">Voir l’appartement</a><a class="cell--link btn btn-sm btn-anchor" href="#simulator">Localiser sur le projet</a></div></div></td></tr>';
  });
  
  $('#appartement__image').css('background-image', 'url('+appImg+')');

}

function filterForm(form){

  // var rooms = [];
  // var prices = [];
  let typeCategory = '';
  let types = [];

  if(typeof form.find("[name='building']:checked").val() !== 'undefined') {
    var buildingEl = form.find("[name='building']:checked");
    var building = buildingEl.val();
    
    // Edit Building image
    var buildingImg = buildingEl.data('img');    
    $('.building__image').css('background-image', 'url('+buildingImg+')');

    
    // on cache les étages non-disponibles pour ce batiment
    var appMaxFloor    = buildingEl.data('maxfloor');
    $("input[name='floors']").each(function() {
      var value = $(this).attr('value');

      if(parseInt(value) > parseInt(appMaxFloor)) {
        $(this).parent().hide();
      } else {
        $(this).parent().show();
      }
    })
    
   
  }

  if(typeof form.find("[name='floors']:checked").val() !== 'undefined') {
    var floors = form.find("[name='floors']:checked").val();
  }

  // if(typeof form.find("[name='rooms']:checked").val() !== 'undefined') {
  //   rooms = [];
  //   $("input[name='rooms']:checked").each( function(){            
  //     rooms.push($(this).val());
  //   });
  // }

  if(typeof form.find("[name='type']:checked").val() !== 'undefined') {
    $("input[name='type']:checked").each(function(){
      typeCategory = $(this).data('type');
      if( typeCategory === 'rooms' ) {
        types.push($(this).data('rooms'));
      } else {
        types.push($(this).data('minprice'));
        types.push($(this).data('maxprice'));
      }      
    });
  }

  // console.log("building :" + building);
  // console.log("floor :" + floors);
  // console.log("type :" + type);

  var rows = $('.table__row');
  // console.log(rows);

  rows.each(function(){
    
    var el = $(this);

    if(el.hasClass('active')){
      return true;
    }

    var rowBuilding = el.data('building');
    var rowRooms = el.data('rooms');
    // var rowType = el.data('type');
    var rowFloor = el.data('floors');
    var rowPrice = el.data('price');

    var filters = [];
    
    // if(rooms.includes(rowRooms.toString()) || rooms.length === 0){
    //   filters.push(1);
    // } else {
    //   filters.push(0);
    // }
    if(types.length !== 0) {
      
      if(typeCategory === 'rooms' ) {
        if (types.includes(rowRooms)){
          filters.push(1);
        } else {
          filters.push(0);
        }
      } else if (typeCategory === 'price') {
        const minPrice = Math.min(...types);
        const maxPrice = Math.max(...types);
        if(minPrice <= rowPrice && rowPrice <= maxPrice) {
          filters.push(1);
        } else {
          filters.push(0);
        }
      }

    } else {
      filters.push(1);
    }

    if(rowBuilding == building || building === 'all'){
      filters.push(1);
    } else {
      filters.push(0);
    }

    if(rowFloor == floors || floors === 'all'){
      filters.push(1);
    } else {
      filters.push(0);
    }

    // console.log(filters);

    if(filters.includes(0)){
      el.hide();
    } else {
      el.show();
    }
  });

  
  // var first = $('tbody').children('.table__row:visible:not(.active):first');
  $('.table__row.d-none').removeClass('d-none');
  if($('.table__row.active').length){
    $('.table__row.active').remove();
  }
  var first = $('tbody').children('.table__row:visible:first');
  if(first.length !== 0){
    toggleActiveRow(first);
  }
}



$(function() {
  var logoTL = new TimelineMax({repeatDelay: 3, repeat: -1, ease:Linear.easeInOut});
  logoTL.to("#lGradient", 0.4, {attr:{y2:1}});
  logoTL.to("#lGradient", 0.4, {attr:{x2:0}}, "-=0.2");
  logoTL.to("#lGradient", 0.4, {attr:{x1:1}}, "-=0.4");
  logoTL.to("#lGradient", 0.4, {attr:{y2:0}}, "-=0.2");
  logoTL.to("#lGradient", 0.4, {attr:{y1:1}}, "-=0.4");
  logoTL.to("#lGradient", 0.4, {attr:{x1:0}}, "-=0.2");
  logoTL.to("#lGradient", 0.4, {attr:{x2:1}}, "-=0.4");
  logoTL.to("#lGradient", 0.4, {attr:{y1:0}}, "-=0.2");

  var pictoTL = new TimelineMax({repeatDelay: 3, repeat: -1, ease:Linear.easeInOut});
  pictoTL.to("#lGradient2", 1.5, {attr:{y2:1}});
  pictoTL.to("#lGradient2", 1.5, {attr:{x2:0}}, "-=0.75");
  pictoTL.to("#lGradient2", 1.5, {attr:{x1:1}}, "-=1.5");
  pictoTL.to("#lGradient2", 1.5, {attr:{y2:0}}, "-=0.75");
  pictoTL.to("#lGradient2", 1.5, {attr:{y1:1}}, "-=1.5");
  pictoTL.to("#lGradient2", 1.5, {attr:{x1:0}}, "-=0.75");
  pictoTL.to("#lGradient2", 1.5, {attr:{x2:1}}, "-=1.5");
  pictoTL.to("#lGradient2", 1.5, {attr:{y1:0}}, "-=0.75");
  

  $('[href^="tel:"]').on('click', function(){
    dataLayer.push({'event':'event-clic-tel'});
  });

  document.addEventListener( 'wpcf7mailsent', function( event ) {
    if ( 5 == event.detail.contactFormId ) {
        dataLayer.push({'event':'event-form-contact-envoye'});
    }
  }, false );

  var floatlabels = new FloatLabels( 'form', {
    // options go here
  });
  
  $("#price-range").ionRangeSlider({
    type: "double",
    min: 80000,
    max: 600000,
    from: 100000,
    to: 300000,
    step: 5000,
    hide_min_max: true,
    grid: true,
    postfix: "€"
  });
  
  $("#price-range").on('change', function () {
    var $inp = $(this);
    var from = $inp.data("from");   // input data-from attribute
    var to = $inp.data("to");       // input data-to attribute
    var value = from+','+to;
    $inp.val(value)
    var v = $inp.val();     // input value in format FROM;TO
  
    // console.log(v, from, to);       // all values
  });

  $("#hero__image_toogle").on("click", function(e) {
    var toggleTitleObject = $(this).children(".image_toggle__title");
    var toggleImageObject = $(this).children(".image_toggle__image");
    var toggleTitleContent = toggleTitleObject.data("night");
    var toggleImgContent = toggleImageObject.data("night");

    if ($("#hero").hasClass("hero__image--day")) {
      toggleTitleContent = toggleTitleObject.data("day");
      toggleImgContent = toggleImageObject.data("day");
    }

    toggleTitleObject.html(toggleTitleContent);
    toggleImageObject.attr("src", toggleImgContent);
    $("#hero").toggleClass("hero__image--day");
  });

  /*
   * Fixed menu
   */

  // use toggleAffix on any data-toggle="affix" elements
  $('[data-toggle="affix"]').each(function() {
    var ele = $(this),
      wrapper = $("<div></div>");

    ele.before(wrapper);
    $(window).on("scroll resize", function() {
      toggleAffix(ele, $(this), wrapper);
    });

    // init
    toggleAffix(ele, $(window), wrapper);
  });

  $(window).on('scroll', function() {
    /* affix after scrolling 100px */
    if ($(document).scrollTop() > 100 && !(jQuery('body').hasClass('post-type-archive')) ) {
      $(".header").addClass("fixed-top affix");
    } else {
      $(".header").removeClass("fixed-top affix");
    }
  });

  $(".header").removeClass("fixed-top affix");

  /*
   * Slick slideshow
   */
  // $(".mobile-slider-home").slick({
  //   infinite: true,
  //   speed: 2000,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   arrows: true,
  //   fade: true,
  //   cssEase: "linear"
  // });

  /**
   * Animated scroll
   */
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top
            },
            1000,
            function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });

  /**
   * Responsive menu animations
   */

  // when opening the responsive menu
  $("#sidebarCollapse").on("click", function() {
    // open responsive menu
    $(".navbar--mobile").toggleClass("active");
    $("a[aria-expanded=true]").attr("aria-expanded", "false");
    $(this).toggleClass("active");
  });

  // if deploy-dropdown is clicked
  $(".deploy-dropdown").on("click", function() {
    // Display submenu placed before deploy-dropdown button
    var prev = $(this).prev();
    var currentState = prev.hasClass("active");

    $(".dropdown-menu").removeClass("active");
    if (prev.hasClass("dropdown-menu") && !currentState) {
      prev.addClass("active");
    }
  });

  $(".overlay").on("click", function() {
    // hide the menu
    $(".navbar.responsive").removeClass("active");
    $(".dropdown-menu").removeClass("active");
    // fade out the overlay
    $(".overlay").fadeOut();
  });

  $('th a').on('click', function (e){
    e.preventDefault();
    var el = $(this);

    el.parent().siblings().find('a').removeClass('asc desc');

    el.toggleClass(function() {
      if($(this).hasClass('asc')){
        return 'desc';
      } else {
        return 'asc';
      }
    });

  });

  
  var table = document.getElementById('appartmentTable');
  if(table !== null){
    
    new Tablesort(table);

    table.addEventListener('beforeSort', function() {
      if($('.table__row.active').length){
        $('.table__row.active').remove();
      }
    });

    table.addEventListener('afterSort', function() {
      var active = $('tbody').children('.table__row.d-none');
        if(active.length !== 0){
          toggleActiveRow(active);
        }
    });
  }
  
  $('.gallery__list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: false,
    asNavFor: '.gallery__nav',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          adaptiveHeight: true,
        }
      },
    ]
  });

  $('.gallery__nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.gallery__list',
    focusOnSelect: true
  });

  $('.table__row').on('click', function(e){
    e.preventDefault();
    
    toggleActiveRow($(this));
    
  });

  var form = $('#filter-form');
  form.find('.filter__input').on( 'change', function(){
    filterForm(form);
  });

  var first = $('tbody').children('.table__row:visible:first');
  if(first.length !== 0){
    toggleActiveRow(first);
  }

  // Add select for mobile version
  $('<label class="appartment__select-label" for="buildingSelect">Bâtiment</label><select id="buildingSelect" for="building" class="appartment__select" />').appendTo(".appartments__filters");
  $('<label class="appartment__select-label" for="flootSelect">Étage</label><select id="floorSelect" for="floors" class="appartment__select" />').appendTo(".appartments__filters");
  $('<label class="appartment__select-label" for="typeSelect">Type d’appartement</label><select id="typeSelect" for="type" class="appartment__select" multiple/>').appendTo(".appartments__filters");

  // Create default option "
  // $("<option />", {
  //   "selected": "selected",
  //   "default" : "default",
  //   "value"   : "",
  //   "text"    : 'Bâtiment'
  // }).appendTo(".appartments__filters select[for='building']");

  // $("<option />", {
  //   "selected": "selected",
  //   "default" : "default",
  //   "value"   : "",
  //   "text"    : 'Étage'
  // }).appendTo(".appartments__filters select[for='floors']");

  // Populate select with buttons
  $(".appartments__filters .filter__group").each(function() {
    var el = $(this);
    var name = $('input',el).attr('name');

    $("<option />", {
        "value"   : $('input', el).attr("value"),
        "text"    : $('label', el).text()
    }).appendTo(".appartments__filters select[for='"+name+"']");

  });

  // Edit main input on select change
  $(".appartment__select").on('change', function() {
    var values = [];
    $('option', this).each(function() {
      if($(this).is(':selected')) {
        // console.log("VALUE : " + $(this).val());
        values.push($(this).val()); 
      }
    })
   
    // Reset des filtres si multiselect
    var selectedValueName = $(this).attr('for');
    if($(this).attr('multiple')) {
      $('.appartments__filters input[name="'+selectedValueName+'"]').prop("checked", false);
    }

    console.log("Value : " + values)
    console.log("For : " + selectedValueName)

    for(var i=0 ; i<values.length ; i++) {
      var selectValue = values[i]
      console.log(selectValue)
      $('.appartments__filters input[value="'+selectValue+'"][name="'+selectedValueName+'"]').prop("checked", true);
    }

    filterForm(form);
  })

  $('.appartment__select').selectpicker({
    'noneSelectedText' : 'Type d\'appartement'
  });

  // Edit select on input change
  $('#filter-form .filter__input').each(function(){
    if($(this).prop('checked')) {
      var id = $(this).attr('id');
      var value = $(this).val();
      var name = $(this).attr("name");
      var label = $('label[for="'+id+'"]').text()

      //Get the text using the value of select
      var el = $(".appartments__filters select[for='"+name+"']").parent();

      var text = $("select[for='"+name+"'][value='"+value+"']").text();
      
      //We need to show the text inside the span that the plugin show
      $('.filter-option-inner-inner', el).text(label);
      //Check the selected attribute for the real select
      $('select', el).val(value);

      $(".appartments__filters select[for='"+name+"'][value='"+value+"']").click();
    }
    
  });

  filterForm(form);
  cloneMenu(".navbar-nav");
});
})(jQuery);